if( $('.top-header-label').length){
	if( isVisible( $('.top-header-label') ) ) {
		$('.top-header').removeClass('header-minify');
	} else {
		$('.top-header').addClass('header-minify');
	}
}

$(window).on('scroll', function() {
	if( $('.top-header-label').length){
		if( isVisible( $('.top-header-label') ) ) {
			$('.top-header').removeClass('header-minify');
		} else {
			$('.top-header').addClass('header-minify');
		}
	}
});

function isVisible(elem){
	var $elem = $(elem);
	var $window = $(window);
	var docViewTop = $window.scrollTop();
	var docViewBottom = docViewTop + $window.height();
	var elemTop = $elem.offset().top;
	var elemBottom = elemTop + $elem.height();

	return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

				
/*eslint-disable */
$('.videoentry').each(function(){
	if( $('.videomodal_hidden').length ){
		var url = $(this).find('.videomodal_hidden').val();
		var count  = $(this).find('.videomodal_hidden').data('count'); 
		var urlpattern = /^(http|https)?:\/\/[a-zA-Z0-9-\.]+\.[a-z]{2,4}/;
		var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
		var match = url.match(regExp);
		if(url.match(urlpattern)){
			if ( match && match[2].length ) {
				var video_thumbnail = $('<div class="frontpage_video_thumb was" data-toggle="modal" data-target="#frontpage_video'+count+'"><img src="//img.youtube.com/vi/'+match[2]+'/sddefault.jpg"></div>');
				$(this).find('.videomodal_hidden'+count).after(video_thumbnail);
				$(this).find('#frontpage_video'+count+' .modal-body').append('<iframe width="100%" height="500" src="//www.youtube.com/embed/' + match[2] + '" frameborder="0" allowfullscreen></iframe>');
			}
		}else{
			var video_thumbnail = $('<div class="frontpage_video_thumb wes" data-toggle="modal" data-target="#frontpage_video'+count+'"><img src="//img.youtube.com/vi/'+url+'/sddefault.jpg"></div>');
			$(this).find('.videomodal_hidden'+count).after(video_thumbnail);
			$(this).find('#frontpage_video'+count+' .modal-body').append('<iframe width="100%" height="500" src="//www.youtube.com/embed/' + url + '" frameborder="0" allowfullscreen></iframe>');
		}
	}
});

/*eslint-enable */
/*eslint-disable */
$(document).on('gform_post_render', function(e, form_id) {
	if ( $('div.validation_error').length > 0 ) {
		$('.banner .content').addClass('form-error');
	}
});
/*eslint-enable */
if( $('#contact-map').length ){
	require('../map/map-single.js');
}


if( $('#microsite-location-map').length ){
	require('../map/map-microsite-location.js');
}


$('.navbar-toggler').on('click', function(){
	$('#mobile-menu').animate({
		width: 'toggle',
	});
});

$('.click-to-scroll').on('click', function(e){
	e.preventDefault();
	$([document.documentElement, document.body]).animate({
		scrollTop: $("#below-fold").offset().top,
	});
});

$(window).on('scroll', function() {
	if($(this).scrollTop() > 1000){
		$('.scrollToTop').fadeIn();
	}else{
		$('.scrollToTop').fadeOut();
	}
});

$('.scrollToTop').click(function(){
	$('html, body').animate({scrollTop : 0},300);
		return false;
});

$('.card-link').on('click', function(){
	$('.card-link').not(this).children('i').removeClass('fa-chevron-circle-up');
	$('.card-link').not(this).children('i').addClass('fa-chevron-circle-down');
	$("i", this).toggleClass("fa-chevron-circle-up fa-chevron-circle-down");
});


// WEBPACK FOOTER //
// ./scripts/includes/common.js